// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"282":"f097c395406508b9","955":"1ed066b36a814498"}[chunkId] + ".js";
};